import { render, staticRenderFns } from "./FollowUpPatientStep12Component.vue?vue&type=template&id=32fbb5bc&scoped=true&"
import script from "./FollowUpPatientStep12Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep12Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep12Component.vue?vue&type=style&index=0&id=32fbb5bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbb5bc",
  null
  
)

export default component.exports